import { SEOHead } from "@/components/SEOHead";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowRight, BarChart3, Brain, FileText, TrendingUp, DollarSign, Database } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

const partners = [
  { name: "OpenAI", logo: "https://static.wixstatic.com/media/5c8a3f_37391ce3a32f4dddacd331ce2c6a4aa9~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/openai-logo-0-2.png" },
  { name: "Partner 2", logo: "https://static.wixstatic.com/media/5c8a3f_797fc9baf1e7404bb429df77eeb63180~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/%D0%94%D0%B8%D0%B7%D0%B0%D0%B9%D0%BD%20%D0%B1%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B8-22.png" },
  { name: "WEX", logo: "https://static.wixstatic.com/media/5c8a3f_b3908a79b75141b8a704a365037185e9~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/EXPANDING%20FUEL%20NETWORK%20Experience%20unparalleled%20convenience%20with%20our%20fuel%20card%20network%2C%20acc.png" },
  { name: "Partner 4", logo: "https://static.wixstatic.com/media/5c8a3f_2d832770b547407b90bf976d46309527~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/EXPANDING%20FUEL%20NETWORK%20Experience%20unparalleled%20convenience%20with%20our%20fuel%20card%20network%2C%20acc.png" },
  { name: "Partner 5", logo: "https://static.wixstatic.com/media/5c8a3f_ed0e25e522704cb29ec42ee8ab957ae3~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/%D0%94%D0%B8%D0%B7%D0%B0%D0%B9%D0%BD%20%D0%B1%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B8-24.png" },
  { name: "Partner 6", logo: "https://static.wixstatic.com/media/5c8a3f_8e40542b0a7d41599ea80c6ed75ac6e1~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/%D0%94%D0%B8%D0%B7%D0%B0%D0%B9%D0%BD%20%D0%B1%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B8-25.png" },
  { name: "Partner 7", logo: "https://static.wixstatic.com/media/5c8a3f_7b51ecdf7ce34cebaaf52cd55671f994~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/%D0%94%D0%B8%D0%B7%D0%B0%D0%B9%D0%BD%20%D0%B1%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B8-27.png" },
  { name: "Partner 8", logo: "https://static.wixstatic.com/media/5c8a3f_f408846b6fda4409a44adec3ffc2b6d4~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/%D0%94%D0%B8%D0%B7%D0%B0%D0%B9%D0%BD%20%D0%B1%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B8-28.png" },
  { name: "Partner 9", logo: "https://static.wixstatic.com/media/5c8a3f_af397e6a139e4a68b6de2e37c84fecff~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/%D0%94%D0%B8%D0%B7%D0%B0%D0%B9%D0%BD%20%D0%B1%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B8-30.png" },
  { name: "Partner 10", logo: "https://static.wixstatic.com/media/5c8a3f_035694b4174844a8805c2f8b344e9eed~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/%D0%94%D0%B8%D0%B7%D0%B0%D0%B9%D0%BD%20%D0%B1%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B8-31.png" },
  { name: "Partner 11", logo: "https://static.wixstatic.com/media/5c8a3f_445b173731ce4cbcba3701c83198ebf1~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/%D0%94%D0%B8%D0%B7%D0%B0%D0%B9%D0%BD%20%D0%B1%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B8-32.png" },
  { name: "Partner 12", logo: "https://static.wixstatic.com/media/5c8a3f_71e1226e94434881a50e99914c004728~mv2.png/v1/fill/w_170,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/%D0%94%D0%B8%D0%B7%D0%B0%D0%B9%D0%BD%20%D0%B1%D0%B5%D0%B7%20%D0%BD%D0%B0%D0%B7%D0%B2%D0%B8-33.png" },
];

const features = [
  {
    icon: FileText,
    title: "Basic TMS Features",
    desc: "Basic TMS Features provide seamless load management, driver and fleet oversight, and integrated accounting to streamline your operations.",
  },
  {
    icon: BarChart3,
    title: "Financial Insights",
    desc: "Monitor weekly profits for your trucks, drivers, and dispatchers, allowing you to make data-driven decisions. Gain complete visibility into your finances to track monthly expenses and analyze trends like Cost Per Mile (CPM), helping you stay profitable.",
  },
  {
    icon: DollarSign,
    title: "Advanced Financial Management",
    desc: "Detailed profit and loss statements, cash flow analysis, and balance sheet insights. Our AR management system helps you resolve chargebacks, shortpays, and other outstanding issues efficiently.",
  },
  {
    icon: Brain,
    title: "AI-Powered Automation",
    desc: "Leverage the power of AI agents that handle time-consuming manual tasks, from reading trucking documents to automating operations, saving you valuable time and resources.",
  },
  {
    icon: Database,
    title: "Data Analysis & Reporting",
    desc: "Empower your team with actionable insights or allow us to manage your analytics, ensuring your decisions are always backed by the right data.",
  },
  {
    icon: TrendingUp,
    title: "Fleet Performance Tracking",
    desc: "Real-time monitoring of fleet performance metrics, driver behavior, and route efficiency to maximize productivity and minimize operational costs across your entire network.",
  },
];

const tmsSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Transportation Management System (TMS)",
  "provider": {
    "@type": "LocalBusiness",
    "name": "AITIM Group"
  },
  "areaServed": "US",
  "description": "Revolutionizing Trucking Operations with Cutting-Edge TMS Solutions including financial insights, automation, and performance tracking."
};

const TMS = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background font-sans">
      <SEOHead 
        title={language === 'ru' ? 'TMS УСЛУГИ' : 'TMS SERVICES'}
        description={language === 'ru'
          ? 'Добро пожаловать в AITIM GROUP – революция в управлении грузоперевозками с помощью передовых TMS-решений'
          : 'Welcome to AITIM GROUP – Revolutionizing Trucking Operations with Cutting-Edge TMS Solutions'}
        canonical="/tms"
        schemaJson={tmsSchema}
      />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative overflow-hidden bg-navy-950 min-h-[600px] flex items-center">
          {/* Animated background */}
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-gradient-to-br from-navy-950 via-navy-900 to-navy-950"></div>
            <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
            <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-primary/8 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>
            {/* Grid lines */}
            <div className="absolute inset-0 opacity-5" style={{backgroundImage: 'linear-gradient(hsl(var(--primary)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--primary)) 1px, transparent 1px)', backgroundSize: '80px 80px'}}></div>
          </div>

          <div className="container mx-auto px-4 relative z-10 pt-32 pb-16 lg:pt-48 lg:pb-32">
            <div className="max-w-4xl mx-auto text-center">
              <div className="inline-block px-4 py-1.5 rounded-full bg-primary/20 text-primary font-semibold text-sm mb-6 border border-primary/30 tracking-wide uppercase">
                {language === 'ru' ? 'Система управления грузоперевозками' : 'Transportation Management System'}
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-7xl font-black text-white mb-6 leading-tight tracking-tight">
                {language === 'ru' ? 'УСЛУГИ' : 'TMS'} <span className="text-primary">{language === 'ru' ? 'TMS' : 'SERVICES'}</span>
              </h1>
              <p className="text-xl lg:text-2xl text-white/80 mb-10 max-w-3xl mx-auto leading-relaxed font-medium">
                {language === 'ru'
                  ? 'Добро пожаловать в AITIM GROUP – революция в управлении грузоперевозками с помощью передовых TMS-решений'
                  : 'Welcome to AITIM GROUP – Revolutionizing Trucking Operations with Cutting-Edge TMS Solutions'}
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/free-consultation">
                  <Button size="lg" className="bg-primary hover:bg-primary/90 text-white rounded-sm px-8 h-14 text-lg w-full sm:w-auto">
                    {language === 'ru' ? 'Получить бесплатное предложение' : 'Get a Free Quote'} <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
                <Link to="/free-consultation">
                  <Button size="lg" variant="outline" className="border-white/20 bg-white/5 text-white hover:bg-white/10 hover:text-white rounded-sm px-8 h-14 text-lg w-full sm:w-auto">
                    {language === 'ru' ? 'Связаться с нами' : 'Contact Us'}
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Partners Section */}
        <section className="py-16 bg-white border-b border-slate-100 overflow-hidden">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-6xl font-black text-navy-950 tracking-tight">
                {language === 'ru' ? 'ПАРТНЁРЫ' : 'PARTNERS'}
              </h2>
            </div>
            {/* Scrolling ticker row 1 */}
            <div className="relative overflow-hidden">
              <div className="flex gap-8 animate-[ticker_30s_linear_infinite] w-max">
                {[...partners, ...partners].map((p, i) => (
                  <div key={i} className="w-28 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100 shrink-0">
                    <img src={p.logo} alt={p.name} className="max-w-full max-h-full object-contain" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-24 bg-slate-50">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mb-16">
              <div className="text-primary font-bold tracking-widest uppercase text-xs mb-4">
                {language === 'ru' ? 'ПОЧЕМУ МЫ' : 'WHY CHOOSE US'}
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-navy-950 mb-6 leading-tight">
                {language === 'ru' ? 'Почему выбирают нас?' : 'Why Choose Us?'}
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                {language === 'ru'
                  ? 'Мы объединяем мощь технологий, ИИ и отраслевую экспертизу для создания систем управления грузоперевозками нового поколения. Наши комплексные решения оптимизируют ваш автопарк, улучшают принятие решений и обеспечивают измеримые результаты.'
                  : 'We combine the power of technology, AI, and industry expertise to bring you the next generation of Trucking Management Systems (TMS). Our comprehensive solutions are designed to optimize your fleet, enhance decision-making, and deliver measurable results for your business.'}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((f, i) => (
                <div key={i} className="group bg-white rounded-2xl p-8 shadow-sm border border-slate-100 hover:-translate-y-2 hover:shadow-2xl hover:shadow-primary/10 hover:border-primary/20 transition-all duration-500 relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-transparent to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  {/* Large background number */}
                  <div className="absolute top-4 right-4 text-8xl font-black text-slate-100 group-hover:text-primary/10 transition-colors duration-500 select-none leading-none">
                    {String(i + 1).padStart(2, '0')}
                  </div>
                  <div className="relative z-10">
                    <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                      <f.icon className="w-7 h-7 text-primary" strokeWidth={1.5} />
                    </div>
                    <h3 className="text-xl font-bold text-navy-950 mb-3 group-hover:text-primary transition-colors duration-300">{f.title}</h3>
                    <p className="text-slate-500 leading-relaxed text-sm">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Quote Banner */}
        <section className="py-24 bg-navy-950 text-white relative overflow-hidden">
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-primary/5"></div>
            <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
            <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>
            {/* Grid */}
            <div className="absolute inset-0 opacity-5" style={{backgroundImage: 'linear-gradient(hsl(var(--primary)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--primary)) 1px, transparent 1px)', backgroundSize: '60px 60px'}}></div>
          </div>
          <div className="container mx-auto px-4 relative z-10 text-center">
            <div className="text-primary font-bold tracking-widest uppercase text-xs mb-6">TMS SOLUTIONS</div>
            <h2 className="text-3xl md:text-5xl font-bold mb-8 max-w-3xl mx-auto leading-tight">
              {language === 'ru'
                ? '"Оптимизируйте операции и повышайте эффективность с TMS-услугами"'
                : '"Streamline Operations and Boost Efficiency with TMS Services"'}
            </h2>
            <p className="text-white/60 max-w-xl mx-auto mb-10 leading-relaxed">
              {language === 'ru'
                ? 'Свяжитесь с нами сегодня и узнайте, как наши TMS-решения могут трансформировать ваш бизнес.'
                : 'Contact us today to learn how our TMS solutions can transform your trucking operations.'}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/free-consultation">
                <Button size="lg" className="bg-primary hover:bg-primary/90 text-white rounded-sm px-10 h-14 text-lg w-full sm:w-auto">
                  {language === 'ru' ? 'Связаться с нами' : 'Contact Us'} <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
              <Link to="/">
                <Button size="lg" variant="outline" className="border-white/20 bg-white/5 text-white hover:bg-white/10 hover:text-white rounded-sm px-10 h-14 text-lg w-full sm:w-auto">
                  {language === 'ru' ? 'Вернуться домой' : 'Back to Home'}
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-24 bg-white overflow-hidden border-t border-slate-100">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-[1920px] mx-auto">
            <div className="lg:w-1/2 relative group w-full flex justify-start overflow-hidden lg:overflow-visible">
              <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
              <img
                src="https://static.wixstatic.com/media/5c8a3f_692872a1103a43c3b151fb190660505e~mv2.png/v1/fill/w_960,h_706,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/5c8a3f_692872a1103a43c3b151fb190660505e~mv2.png"
                alt="AITIM Capital Card"
                className="w-full max-w-none lg:w-[110%] lg:-ml-12 drop-shadow-[0_20px_50px_rgba(0,0,0,0.15)] group-hover:-translate-y-4 group-hover:scale-105 transition-all duration-700 relative z-10"
              />
            </div>
            <div className="lg:w-1/2 px-4 lg:pr-12 xl:pr-24 w-full">
              <div className="max-w-xl mx-auto lg:mx-0">
                <div className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary font-bold text-xs mb-6 tracking-widest uppercase">
                  {language === 'ru' ? 'Почему мы' : 'Why Choose Us'}
                </div>
                <h2 className="text-5xl md:text-7xl font-black text-navy-950 mb-16 tracking-tight">AITIM GROUP</h2>
                <div className="grid grid-cols-2 gap-x-8 gap-y-12">
                  {[
                    { value: "10+", label: language === 'ru' ? 'ЛЕТ ОПЫТА' : 'YEARS OF\nEXPERIENCE' },
                    { value: "7000+", label: language === 'ru' ? 'ГРУЗОВИКОВ В СЕТИ' : 'TRUCKS IN OUR\nNETWORK' },
                    { value: "100%", label: language === 'ru' ? 'УДОВЛЕТВОРЁННОСТЬ' : 'CUSTOMER\nSATISFACTION' },
                    { value: "20+", label: language === 'ru' ? 'НАГРАДЫ' : 'AWARDS AND\nRECOGNITIONS' },
                  ].map((stat, i) => (
                    <div key={i} className="group">
                      <div className="text-4xl md:text-6xl font-light text-navy-950 mb-4 group-hover:scale-110 origin-left transition-transform duration-300">{stat.value}</div>
                      <div className="h-0.5 bg-navy-950 w-full mb-4 relative overflow-hidden">
                        <div className="absolute top-0 left-0 h-full bg-primary w-0 group-hover:w-full transition-all duration-500"></div>
                      </div>
                      <div className="text-sm font-medium tracking-widest text-navy-950 uppercase group-hover:text-primary transition-colors whitespace-pre-line">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TMS;
